<template>
  <div class="luck-award-popup">
    <div class="award-wrapper">
      <img class="bg" src="./assets/img/receiveBg.png" />
      <div>
        <img @click="onClose" class="close" src="./assets/img/close.png" />
      </div>
      <div class="result-content">
        <template v-if="hasAward">
          <span class="title">恭喜获得</span>
          <div>{{ awardName }}</div>
          <div  class="img-wrapper">
            <img v-if="awardImg" :src="awardImg" alt="" height="100">
          </div>
          <div>
            <div class="award-btn" @click="onConfirm">领取奖励</div>
          </div>
        </template>
        <template v-else>
          <span>未抽中！感谢参与</span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { convertDownloadUrl,BoundFailedType } from 'dygc'

export default {
  name: 'LuckAwardPopup',
  props: {
    award: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    hasAward() {
      return this.award.boundFailedType === null
    },
    awardName() {
      if(this.isRed) return `${this.award.awardYuanAmount}元红包`
      return this.award.awardName
    },
    awardImg() {
      let url = this.award.awardImg
      if (!url) return ''
      if(url.startsWith('http')) return url
      return convertDownloadUrl(url)
    },
    isRed() {
      return this.award.lotteryCategory === 4
    }
  },
  methods: {
    onConfirm() {
      this.$emit('confirm')
    },
    onClose() {
      if(!this.hasAward) {
        this.$emit('close')
      }else {
        this.$emit('confirm')
      }

      // this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
.luck-award-popup {
  position: fixed;
  z-index: 3000;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, .25);
  display: flex;

  .award-wrapper {
    width: 343px;
    height: 408.5px;
    position: relative;
    margin: auto;
  }

  .img-wrapper {
    height: 110px;
  }

  .close {
    width: 24px;
    height: 24px;
    position: absolute;
    right: 29px;
    top: 0;
  }

  .result-content {
    position: absolute;
    width: 100%;
    left: 0;
    top: 81px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    img {
      height: 110px;
    }
  }

  .award-btn {
    margin-top: 10px;
    width: 160px;
    height: 32px;
    background-image: linear-gradient(180deg, #ffea86 0%, #ffb544 100%);
    box-shadow: inset 0 -3px 0 0 #e66c00;
    border-radius: 22px;
    font-weight: 500;
    font-size: 14px;
    color: #e34152;
    text-align: center;
    line-height: 32px;
    cursor: pointer;
  }
}
</style>